{
  "blocks": [
    {
      "id": "proc-surgical-sperm-retrieval",
      "kind": "procedure",
      "tags": ["his", "clinic-visit"],
      "title": "Surgical sperm retrieval",
      "subtitle": "Surgical extraction of sperm directly from the testicle or epididymis",
      "body": {
        "procedureName": "Surgical sperm retrieval",
        "category": "retrieval",
        "description": "A surgical procedure to obtain sperm directly from the testicle (TESE/micro-TESE) or epididymis (MESA/PESA) when sperm is not present in the ejaculate. Used for men with obstructive or non-obstructive azoospermia.",
        "howItWorks": "The procedure is performed under local anesthesia with sedation or general anesthesia, depending on the technique. In TESE (testicular sperm extraction), a small incision is made in the scrotum and a tiny piece of testicular tissue is removed and examined under a microscope for sperm. In micro-TESE, an operating microscope helps identify the most promising tubules, improving sperm recovery rates. In MESA (microsurgical epididymal sperm aspiration), sperm is aspirated from the epididymis. Retrieved sperm are used immediately for ICSI or frozen for future use.",
        "duration": "30–90 minutes depending on technique",
        "anesthesia": "local",
        "painAndComfort": [
          "Scrotal soreness and swelling are common for several days after the procedure."
        ],
        "recoveryTime": "1–3 days of rest; avoid heavy activity for 1–2 weeks",
        "whatToExpect": [
          "The procedure is performed as an outpatient, and you go home the same day",
          "Mild to moderate scrotal soreness and swelling for several days",
          "Ice packs and over-the-counter pain medication usually manage discomfort",
          "You'll know whether sperm was found shortly after the procedure",
          "Retrieved sperm can be frozen for use in a future IVF/ICSI cycle"
        ],
        "results": [
          {
            "label": "Sperm found",
            "detail": "The lab can often tell shortly after the procedure whether sperm were found in the retrieved tissue or fluid."
          },
          {
            "label": "How it is used",
            "detail": "Retrieved sperm may be used for ICSI the same day if coordinated with egg retrieval, or frozen for a future IVF cycle."
          },
          {
            "label": "If none are found",
            "detail": "Your doctor should review whether repeat retrieval, donor sperm, or another plan is appropriate."
          }
        ],
        "prepInstructions": [
          "Follow your surgeon's instructions about fasting before anesthesia",
          "Arrange for someone to drive you home after the procedure",
          "Wear loose, supportive underwear and comfortable clothing",
          "Stop blood-thinning medications as directed by your doctor",
          "Discuss with your doctor whether to coordinate the procedure with your partner's egg retrieval"
        ],
        "risks": [
          "Scrotal pain, swelling, and bruising (resolves within 1–2 weeks)",
          "Rare: infection or hematoma at the surgical site",
          "Very rare: testicular atrophy with repeated procedures",
          "No guarantee that sperm will be found, especially in non-obstructive azoospermia"
        ],
        "forWhom": "him",
        "frBody": {
          "procedureName": "Prélèvement chirurgical de spermatozoïdes",
          "description": "Geste chirurgical visant à recueillir des spermatozoïdes directement dans le testicule (TESE/micro-TESE) ou l'épididyme (MESA/PESA) lorsque le sperme éjaculé n'en contient pas. Indiqué en cas d'azoospermie obstructive ou non obstructive.",
          "howItWorks": "Le geste est réalisé sous anesthésie locale avec sédation ou sous anesthésie générale selon la technique. En TESE (extraction testiculaire), une petite incision scrotale permet de prélever un fragment de tissu testiculaire examiné au microscope à la recherche de spermatozoïdes. En micro-TESE, un microscope opératoire aide à repérer les tubules les plus prometteurs et améliore le taux de recueil. En MESA (aspiration épididymaire microchirurgicale), les spermatozoïdes sont aspirés dans l'épididyme. Les spermatozoïdes recueillis sont utilisés immédiatement pour une ICSI (injection intracytoplasmique de spermatozoïde) ou congelés pour un usage ultérieur.",
          "duration": "30 à 90 minutes selon la technique",
          "recoveryTime": "1 à 3 jours de repos ; éviter les efforts intenses pendant 1 à 2 semaines",
          "whatToExpect": [
            "Geste réalisé en ambulatoire ; vous rentrez chez vous le jour même",
            "Sensibilité et gonflement scrotal légers à modérés pendant plusieurs jours",
            "La glace et des antalgiques en vente libre gèrent habituellement l'inconfort",
            "Vous saurez peu après si des spermatozoïdes ont été retrouvés",
            "Les spermatozoïdes recueillis peuvent être congelés pour un cycle ultérieur de FIV (fécondation in vitro) ou d'ICSI"
          ],
          "results": [
            {
              "label": "Spermatozoïdes retrouvés",
              "detail": "Le laboratoire peut souvent dire peu après le geste si des spermatozoïdes ont été retrouvés dans le tissu ou le liquide prélevé."
            },
            {
              "label": "Comment c'est utilisé",
              "detail": "Les spermatozoïdes recueillis peuvent être utilisés pour ICSI le jour même si le geste est coordonné avec une ponction, ou congelés pour un cycle ultérieur."
            },
            {
              "label": "Si aucun n'est retrouvé",
              "detail": "Votre médecin doit revoir si une nouvelle tentative, un don de sperme ou un autre plan est approprié."
            }
          ],
          "prepInstructions": [
            "Suivez les consignes de jeûne avant l'anesthésie",
            "Prévoyez quelqu'un pour vous raccompagner",
            "Portez des sous-vêtements amples et soutenants et des vêtements confortables",
            "Arrêtez les anticoagulants selon les indications de votre médecin",
            "Discutez avec votre médecin de la coordination du geste avec la ponction de votre partenaire"
          ],
          "risks": [
            "Douleur, gonflement et ecchymoses scrotaux (résolutifs en 1 à 2 semaines)",
            "Rare : infection ou hématome au site opératoire",
            "Très rare : atrophie testiculaire en cas de gestes répétés",
            "Aucune garantie de retrouver des spermatozoïdes, en particulier en cas d'azoospermie non obstructive"
          ]
        }
      },
      "sources": [
        {
          "title": "Diagnosis and Treatment of Infertility in Men: AUA/ASRM Guideline",
          "authors": "Schlegel PN, Sigman M, Collura B, et al.",
          "journal": "Journal of Urology",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/diagnosis-and-treatment-of-infertility-in-men-auaasrm-guideline-part-i-2020/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
